




























//////////////////////
//      Imports     //
//////////////////////
import Vue from "vue";
import LabelSlotsStructure from "@/components/LabelSlotsStructure.vue";
import { useStore } from "@/store/store";
import {AllFrameTypesIdentifier, FrameLabel} from "@/types/types";
import { mapStores } from "pinia";
import scssVars from "@/assets/style/_export.module.scss";

//////////////////////
//     Component    //
//////////////////////
export default Vue.extend({
    name: "FrameHeader",

    components: {
        LabelSlotsStructure,
    },

    props: {
        // We need an array of labels in the case there are more
        // than a label in the frame (e.g. `with` ... `as ... ) 
        labels: Array,
        frameId: Number,
        frameType: String,
        isDisabled: Boolean,
        frameAllowChildren: Boolean,
        erroneous: Boolean,
        wasLastRuntimeError: Boolean,
        onFocus: Function, // Handler for focus/blur the header (see Frame.vue)
    },

    computed:{
        ...mapStores(useStore),
        
        isCommentFrame(): boolean{
            return this.frameType===AllFrameTypesIdentifier.comment;
        },

        scssVars() {
            // just to be able to use in template
            return scssVars;
        },
    },

    methods:{
        isLabelHidden(labelDetails: FrameLabel): boolean {
            return !(labelDetails.showLabel??true);
        },

        areSlotsShown(labelDetails: FrameLabel): boolean {
            return labelDetails.showSlots??true;
        },
    },
});
